module.exports = __webpack_public_path__ + "static/datamap-logo-dbbf990a624d1a855a91208ea630dcaa.png";